import React from 'react';

function Tariffs() {
  const plans = [
    {
      name: 'Economy',
      price: '990 ₽/мес',
      description: 'Для старта и небольших проектов',
      features: [
        'Кассовый прогноз на 14 дней',
        'Налоговый календарь',
        'Проверка 5 контрагентов/мес',
        'Базовые договоры',
        'Email-уведомления',
      ],
      color: '#6366F1',
      button: 'Выбрать Economy',
    },
    {
      name: 'Autopilot',
      price: '4 990 ₽/мес',
      description: 'Для растущего бизнеса',
      features: [
        'Всё из Economy',
        'Безлимитная проверка контрагентов',
        'ИИ-поиск налоговых льгот',
        'Подключение банков (Сбер, Точка)',
        'Кредитный консьерж',
        'SSE-уведомления в реальном времени',
      ],
      color: '#10B981',
      button: 'Выбрать Autopilot',
      popular: true,
    },
    {
      name: 'Production ERP',
      price: '7 990 ₽/мес + 1 000 ₽/сотр.',
      description: 'Для производственных компаний',
      features: [
        'Всё из Autopilot',
        'Учёт закупок и склад',
        'Управление производством (ERP)',
        'Спецификации продуктов (BOM)',
        'Производственные заказы',
        'Расчёт себестоимости и маржи',
      ],
      color: '#F59E0B',
      button: 'Выбрать Production',
    },
  ];

  return (
    <div>
      <h2>💳 Тарифы</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 24 }}>
        Выберите план под ваш бизнес. Первые 14 дней — бесплатно для всех тарифов.
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, maxWidth: 900 }}>
        {plans.map((plan, i) => (
          <div key={i} style={{
            background: '#1E293B',
            padding: 24,
            borderRadius: 12,
            border: plan.popular ? `2px solid ${plan.color}` : '1px solid #334155',
            position: 'relative',
          }}>
            {plan.popular && (
              <div style={{
                position: 'absolute',
                top: -12,
                left: '50%',
                transform: 'translateX(-50%)',
                background: plan.color,
                color: '#fff',
                padding: '4px 12px',
                borderRadius: 12,
                fontSize: 12,
                fontWeight: 600,
              }}>
                Популярный
              </div>
            )}
            <h3 style={{ fontSize: 20, marginBottom: 4 }}>{plan.name}</h3>
            <div style={{ fontSize: 24, fontWeight: 700, color: plan.color, marginBottom: 8 }}>{plan.price}</div>
            <p style={{ color: '#94A3B8', fontSize: 13, marginBottom: 16 }}>{plan.description}</p>
            <ul style={{ listStyle: 'none', padding: 0, marginBottom: 20 }}>
              {plan.features.map((f, j) => (
                <li key={j} style={{ padding: '6px 0', fontSize: 13, color: '#94A3B8', borderBottom: '1px solid #334155' }}>
                  ✅ {f}
                </li>
              ))}
            </ul>
            <button style={{
              width: '100%',
              padding: 12,
              background: plan.color,
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              cursor: 'pointer',
              fontWeight: 600,
              fontSize: 14,
            }}>
              {plan.button}
            </button>
          </div>
        ))}
      </div>

      <p style={{ color: '#94A3B8', fontSize: 12, marginTop: 20 }}>
        💡 Оплата через ЮKassa. Демо-режим — платежи не списываются.
      </p>
    </div>
  );
}

export default Tariffs;